module.exports = __webpack_public_path__ + "static/mo12-41df33c77992d2a2a264f2db0f2c3d40.png";